import { render, staticRenderFns } from "./OnexappInstall.vue?vue&type=template&id=6d9d2bf6&"
import script from "./OnexappInstall.vue?vue&type=script&lang=js&"
export * from "./OnexappInstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports